import react, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import Table from "../../../Layout/Table/Table";
import { Puff } from "react-loading-icons";
import {
  Input,
  TextArea,
  Select,
  SelectCountries,
  InputImage,
  Switch,
} from "../../../Layout/Forms/Form";
import BillingRequests from "../BillingRequests";
import NavBar from "../../../../components/NavBar";

const BillingCheckout = () => {
  const navigate = useNavigate();
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    form: {
      id: 0,
      cicloFaturacao: 1,
      price: [],
    },
    billingForm: {
      id: 0,
      name_comercial: "",
      name_company: "",
      nipc: "",
      email: "",
      phone_country: "",
      phone_number: "",
      address: "",
      city: "",
      postal_code: "",
      country: "",
    },
    info: {
      product: [],
      product_lines: [],
    },
    errors: {},
  });

  const requestAccountInfo = async () => {
    setIsLoading(true);
    document.title = "Account Info | Nightspot Dashboard";
    let info = await BillingRequests.getCheckoutInfo(params);
    if (info && info.status) {
      setData(info.data);
    } else {
      navigate("/my/nightspots/");
    }
    setIsLoading(false);
  };

  useEffect(async () => {
    requestAccountInfo();
  }, []);

  const handlerCheckout = async () => {
    setIsLoading(true);
    let request = await BillingRequests.saveCheckout(data.form);
    if (request && request.status) {
      navigate(`/my/billing/checkout/${data.form.id}/finish`);
    } else {
      setData({
        ...data,
        errors: request.errors,
      });
    }
    setIsLoading(false);
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const ListPlanLines = () => {
    const Lines = () => {
      return data.info.product_lines.map((item, key) => {
        if (item.unit == "un" || item.unit == "days") {
          return (
            <li key={key}>
              <span className="me-2">{item.label}:</span>
              {item.quantity}
            </li>
          );
        } else if (item.unit === "check") {
          return (
            <li key={key}>
              <span className="me-2">{item.label}</span>
              {item.quantity == 1 ? (
                <i className="fa-solid fa-circle-check"></i>
              ) : (
                <i className="fa-solid fa-ban"></i>
              )}
            </li>
          );
        } else {
          return null;
        }
      });
    };

    return (
      <ul className="nav-billing less-space">
        <Lines />
      </ul>
    );
  };

  const BillingAccountDetails = () => {
    return (
      <ul className="nav-billing less-space">
        <li>
          <span>Nome Empresa:</span> {data.billingForm.name_company}{" "}
        </li>
        <li>
          <span>NIF:</span> {data.billingForm.nipc}{" "}
        </li>
        <li>
          <span>Email:</span> {data.billingForm.email}{" "}
        </li>
        <li>
          <span>Telefone:</span> {data.billingForm.phone_number}{" "}
        </li>
        <li>
          <span>Rua:</span> {data.billingForm.address}{" "}
        </li>
        <li>
          <span>Cidade:</span> {data.billingForm.city}{" "}
        </li>
        <li>
          <span>Código Postal:</span> {data.billingForm.postal_code}{" "}
        </li>
        <li>
          <span>País:</span> {data.billingForm.country}{" "}
        </li>
      </ul>
    );
  };

  const PriceResume = () => {
    const prices = data.form.price;
    if (prices.length == 0) return 0;
    return prices["price_" + data.form.cicloFaturacao + "months"];
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-8">
                    <h2 className="dashboard-h2">Checkout</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/nightspots">Lista Nightspots</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={`/my/billing/manager/${params.id_venues}`}>
                            Gestão de subscrição
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Checkout</li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8">
                    <div className="row">
                      <div className="col-12">
                        <div className="list-group list-group-radio d-grid gap-2 border-0">
                          <div className="position-relative">
                            <label
                              className="list-group-item py-3 pe-5"
                              htmlFor="sponsor_5days"
                              style={{
                                backgroundColor: "#0a1116",
                                color: "#dee2e6",
                              }}
                            >
                              <strong className="fw-semibold">
                                {data.info.product.description}
                              </strong>
                              {/* <ul className="d-block small opacity-75 mt-2">
                                                                <li>Eventos ilimitados</li>
                                                                <li>Sistema de guestlist</li>
                                                                <li>Relatório de interações do spot</li>
                                                            </ul> */}
                              <ListPlanLines />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="list-group list-group-radio d-grid gap-2 border-0">
                          <div className="position-relative">
                            <label
                              className="list-group-item py-3 pe-5"
                              style={{
                                backgroundColor: "#0a1116",
                                color: "#dee2e6",
                              }}
                            >
                              <strong className="fw-semibold">
                                Dados Faturação
                              </strong>
                              <BillingAccountDetails />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 ">
                    <div className="row sticky-top">
                      <div className="col-12">
                        <div className="row ">
                          <div className="col-12">
                            <div
                              className="p-3"
                              style={{
                                backgroundColor: "#0a1116",
                                color: "#dee2e6",
                              }}
                            >
                              <h4>Ciclo de Faturação</h4>
                              <div className="row">
                                <div className="col-12">
                                  <div className="list-group list-group-radio d-grid gap-2 border-0 mt-2">
                                    <div className="position-relative">
                                      <input
                                        style={{ zIndex: 999, top: "35%" }}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            form: {
                                              ...data.form,
                                              cicloFaturacao: 1,
                                            },
                                          })
                                        }
                                        className="form-check-input position-absolute  end-0 me-3 fs-5"
                                        type="radio"
                                        name="listGroupRadioGrid"
                                        id="faturacao_mensal"
                                        value=""
                                        checked={
                                          data.form.cicloFaturacao == 1
                                            ? "checked"
                                            : ""
                                        }
                                      />
                                      <label
                                        className="list-group-item py-3 pe-5"
                                        htmlFor="faturacao_mensal"
                                        style={{
                                          backgroundColor: "#060b0e",
                                          color: "#dee2e6",
                                        }}
                                      >
                                        <strong className="fw-semibold">
                                          Mensal
                                        </strong>
                                      </label>
                                    </div>

                                    <div className="position-relative">
                                      <input
                                        style={{ zIndex: 999, top: "35%" }}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            form: {
                                              ...data.form,
                                              cicloFaturacao: 3,
                                            },
                                          })
                                        }
                                        className="form-check-input position-absolute  end-0 me-3 fs-5"
                                        type="radio"
                                        name="listGroupRadioGrid"
                                        id="faturacao_trimestral"
                                        value=""
                                        checked={
                                          data.form.cicloFaturacao == 3
                                            ? "checked"
                                            : ""
                                        }
                                      />
                                      <label
                                        className="list-group-item py-3 pe-5"
                                        htmlFor="faturacao_trimestral"
                                        style={{
                                          backgroundColor: "#060b0e",
                                          color: "#dee2e6",
                                        }}
                                      >
                                        <strong className="fw-semibold">
                                          Trimestral
                                        </strong>
                                      </label>
                                    </div>

                                    <div className="position-relative">
                                      <input
                                        style={{ zIndex: 999, top: "35%" }}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            form: {
                                              ...data.form,
                                              cicloFaturacao: 6,
                                            },
                                          })
                                        }
                                        className="form-check-input position-absolute  end-0 me-3 fs-5"
                                        type="radio"
                                        name="listGroupRadioGrid"
                                        id="faturacao_semestral"
                                        value=""
                                        checked={
                                          data.form.cicloFaturacao == 6
                                            ? "checked"
                                            : ""
                                        }
                                      />
                                      <label
                                        className="list-group-item py-3 pe-5"
                                        htmlFor="faturacao_semestral"
                                        style={{
                                          backgroundColor: "#060b0e",
                                          color: "#dee2e6",
                                        }}
                                      >
                                        <strong className="fw-semibold">
                                          Semestral
                                        </strong>
                                      </label>
                                    </div>

                                    <div className="position-relative">
                                      <input
                                        style={{ zIndex: 999, top: "35%" }}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            form: {
                                              ...data.form,
                                              cicloFaturacao: 12,
                                            },
                                          })
                                        }
                                        className="form-check-input position-absolute  end-0 me-3 fs-5"
                                        type="radio"
                                        name="listGroupRadioGrid"
                                        id="faturacao_anual"
                                        value=""
                                        checked={
                                          data.form.cicloFaturacao == 12
                                            ? "checked"
                                            : ""
                                        }
                                      />
                                      <label
                                        className="list-group-item py-3 pe-5"
                                        htmlFor="faturacao_anual"
                                        style={{
                                          backgroundColor: "#060b0e",
                                          color: "#dee2e6",
                                        }}
                                      >
                                        <strong className="fw-semibold">
                                          Anual
                                        </strong>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div
                              className="p-3"
                              style={{
                                backgroundColor: "#0a1116",
                                color: "#dee2e6",
                              }}
                            >
                              <h4>Resumo</h4>
                              <div className="row">
                                <div className="col-12">
                                  <div className="list-group list-group-radio d-grid gap-2 border-0 mt-2">
                                    <div className="position-relative">
                                      <label
                                        className="list-group-item py-3"
                                        htmlFor="faturacao_anual"
                                        style={{
                                          backgroundColor: "#060b0e",
                                          color: "#dee2e6",
                                        }}
                                      >
                                        <strong className="fw-semibold">
                                          Total:
                                        </strong>
                                        <strong className="fw-semibold float-end text-end">
                                          <PriceResume />€ + IVA
                                        </strong>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12 d-grid gap-0">
                            <button
                              className="btn btn-primary fs-4"
                              onClick={() => handlerCheckout()}
                            >
                              Continuar&nbsp;
                              <i className="fa-solid fa-angle-right fs-5"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default BillingCheckout;
